import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const createPDFFromElement = async (elementId = 'quotation-page') => {
  const element = document.querySelector(`.${elementId}`);

  if (!element) {
    throw new Error('Quotation page element not found');
  }

  // Temporarily hide print-hidden elements
  const hiddenElements = document.querySelectorAll('.print\\:hidden');
  hiddenElements.forEach(el => {
    el.style.display = 'none';
  });

  // Create canvas from element
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff',
  });

  // Restore hidden elements
  hiddenElements.forEach(el => {
    el.style.display = '';
  });

  // Calculate PDF dimensions
  const imgWidth = 297; // A4 width in mm
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  const pdf = new jsPDF('l', 'mm', 'a4');
  let heightLeft = imgHeight;
  let position = 0;

  // Add image to PDF, handling multiple pages if needed
  const imgData = canvas.toDataURL('image/png');

  while (heightLeft >= 0) {
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= 210; // A4 height in mm
    position -= 210;

    if (heightLeft > 0) {
      pdf.addPage();
    }
  }

  return pdf;
};

export const exportQuotationPDF = async (elementId = 'quotation-page') => {
  try {
    const pdf = await createPDFFromElement(elementId);

    // Generate filename with current date
    const now = new Date();
    const dateStr = now
      .toLocaleDateString('vi-VN')
      .split('/')
      .reverse()
      .join('-');
    const filename = `BaoGia_${dateStr}.pdf`;

    // Download PDF
    pdf.save(filename);
  } catch (error) {
    console.error('Error exporting PDF:', error);
    throw error;
  }
};

export const printQuotationPDF = async (elementId = 'quotation-page') => {
  try {
    const pdf = await createPDFFromElement(elementId);

    // Create blob from PDF
    const blob = pdf.output('blob');
    const blobUrl = URL.createObjectURL(blob);

    // Create a new window for printing
    const printWindow = window.open(blobUrl, '_blank');

    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
      };
    } else {
      throw new Error('Could not open print window');
    }
  } catch (error) {
    console.error('Error printing PDF:', error);
    throw error;
  }
};
